import { jsxs as i, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as t } from "./index.es2447.js";
function e({ size: l = t }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.468262", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M32.6944 32.621C32.6944 37.4989 28.7251 41.4683 23.8472 41.4683C18.9693 41.4683 15 37.4989 15 32.621C15 27.7431 18.9693 23.7738 23.8472 23.7738C28.7251 23.7738 32.6944 27.7431 32.6944 32.621Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M40 16.4683H21V24.2439C21.8939 23.9392 22.8516 23.7738 23.8472 23.7738C28.7251 23.7738 32.6944 27.7431 32.6944 32.621C32.6944 34.4091 32.1611 36.0751 31.2451 37.4683H40V16.4683Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M35.5075 18.1404H34.3414V19.5472C33.7477 19.6105 33.2566 19.8176 32.8868 20.1839C32.4779 20.5888 32.2756 21.1011 32.2756 21.7041C32.2756 21.9056 32.3009 22.0962 32.3534 22.2747C32.4033 22.4441 32.4661 22.5969 32.5435 22.7312C32.6257 22.874 32.7401 23.0041 32.881 23.1229C33.0118 23.2332 33.1353 23.3263 33.2513 23.4009C33.372 23.4785 33.5287 23.5567 33.7168 23.6364C33.9011 23.7145 34.058 23.7772 34.1868 23.8239C34.3143 23.8701 34.4854 23.9276 34.6988 23.9962L34.7014 23.997C34.933 24.0683 35.1169 24.1297 35.2545 24.1814C35.3886 24.2318 35.5273 24.2945 35.6707 24.3698C35.8084 24.4421 35.9022 24.5116 35.9618 24.5747C36.0235 24.64 36.0775 24.7228 36.1219 24.8266C36.1619 24.9199 36.1841 25.0295 36.1841 25.1589C36.1841 25.4366 36.0834 25.6396 35.8822 25.792C35.6708 25.9522 35.3843 26.0418 35.0041 26.0418C34.675 26.0418 34.3381 25.9707 33.9918 25.8244C33.6489 25.6795 33.3385 25.4686 33.0599 25.1892L32.891 25.0199L32.0502 26.0423L32.1918 26.1813C32.8183 26.7962 33.5359 27.1718 34.3414 27.2997V28.6849H35.5075V27.3155C36.1124 27.2349 36.6122 27.018 36.9899 26.651C37.4094 26.2434 37.6158 25.7201 37.6158 25.0997C37.6158 24.8859 37.5919 24.6847 37.5422 24.4971C37.4948 24.3183 37.4356 24.158 37.3629 24.0185C37.2846 23.8684 37.1716 23.7314 37.0304 23.6062C36.8993 23.4901 36.7751 23.3925 36.6581 23.3154C36.5355 23.2344 36.3708 23.1529 36.1705 23.0697C35.9735 22.9879 35.8061 22.9232 35.6691 22.8763C35.5369 22.8309 35.3501 22.7686 35.1093 22.6895C34.8952 22.6183 34.7278 22.5587 34.6057 22.5105C34.4859 22.4632 34.3523 22.4024 34.2047 22.3275C34.0626 22.2554 33.9677 22.1897 33.9096 22.1334C33.8492 22.0748 33.7958 22.0017 33.7507 21.9116C33.7122 21.8347 33.6914 21.747 33.6914 21.6448C33.6914 21.3864 33.7821 21.2072 33.9567 21.0779C34.1443 20.9391 34.4069 20.859 34.7651 20.859C35.0117 20.859 35.2928 20.9105 35.6108 21.0197C35.9247 21.1276 36.208 21.2771 36.4618 21.4677L36.6283 21.5929L37.457 20.5756L37.2831 20.4394C37.0191 20.2327 36.7136 20.0541 36.3685 19.9023C36.0823 19.7766 35.7953 19.6828 35.5075 19.6219V18.1404Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C("path", { d: "M23.6667 19.681H29.4444V18.4778H23.6667V19.681Z", fill: "#5E63E5" }),
        /* @__PURE__ */ C("path", { d: "M29.4444 22.5699H26.5556V21.3666H29.4444V22.5699Z", fill: "#5E63E5" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M24.5766 34.0684L24.8768 27.9863H22.8405L23.1406 34.0684H24.5766Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M23.8532 37.2556C24.1749 37.2556 24.426 37.1612 24.6065 36.9724C24.787 36.7835 24.8773 36.5252 24.8773 36.1973C24.8773 35.857 24.788 35.5956 24.6095 35.4129C24.4309 35.2303 24.1789 35.139 23.8532 35.139C23.5158 35.139 23.2588 35.2283 23.0822 35.4067C22.9057 35.5852 22.8174 35.8487 22.8174 36.1973C22.8174 36.5335 22.9076 36.7939 23.0881 36.9786C23.2686 37.1633 23.5236 37.2556 23.8532 37.2556Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.3814 38.5794H39.5556C40.3533 38.5794 41 37.9327 41 37.1349V16.9127C41 16.115 40.3533 15.4683 39.5556 15.4683H22.2222C21.4245 15.4683 20.7778 16.115 20.7778 16.9127V24.323C17.408 25.5736 15 28.8218 15 32.621C15 37.4989 18.9693 41.4683 23.8472 41.4683C26.4323 41.4683 28.7622 40.3534 30.3814 38.5794ZM39.5556 16.5516H22.2222C22.0228 16.5516 21.8611 16.7133 21.8611 16.9127V23.9986C22.4998 23.8516 23.1646 23.7738 23.8472 23.7738C28.7251 23.7738 32.6944 27.7432 32.6944 32.621C32.6944 34.421 32.154 36.0973 31.2268 37.496H39.5556C39.755 37.496 39.9167 37.3344 39.9167 37.1349V16.9127C39.9167 16.7133 39.755 16.5516 39.5556 16.5516ZM23.8472 40.3849C28.1268 40.3849 31.6111 36.9006 31.6111 32.621C31.6111 28.3415 28.1268 24.8571 23.8472 24.8571C19.5676 24.8571 16.0833 28.3415 16.0833 32.621C16.0833 36.9006 19.5676 40.3849 23.8472 40.3849Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
e.__tags = [];
export {
  e as MetricRiskIcon
};
//# sourceMappingURL=index.es420.js.map
